module.exports = __webpack_public_path__ + "7c7f1f2d0b55e8d55045ae15160c1527.svg";